/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import { Typography } from "@material-ui/core";

/* Data Imports */
import AppConfig from "../../../../AppConfig";

/* Define all styles */
const useStyles = makeStyles((theme) => ({
  iconTextRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    width: "100%",
      gap: "0.5rem",
    },
    gap: "1rem",
    width: "25%",
    border: "1px solid #FFFFFF33",
    borderRadius: "1rem",
    padding: "1rem",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    alignItems: "space-between",
    justifyContent: "flex-start",
  },
  heading: {
    fontWeight: 500,
    fontSize: "1rem",
    lineHeight: "1.5rem",
color: "#FFFFFF",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.875rem",
      lineHeight: "1rem",
      color: "#212121",
    },
  },
}));

const AmenitiesIconCard = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={`${classes.iconTextRow} ${props.className}`}>
        <img
          alt={AppConfig.imageAltText}
          loading="lazy"
          referrerPolicy="no-referrer"
          height={53}
          width={48}
          src={props.icon ? props.icon : "/images/icons/config/area.svg"}
        />
        <div className={classes.text}>
          <Typography
            variant="body2"
            component="span"
            className={classes.heading}
          >
            {props.title ? props.title : "Modern"}
          </Typography>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AmenitiesIconCard;
